module.exports = __webpack_public_path__ + "img/flags/ER.98c02cd.png";